import { INavData } from '@coreui/angular';

export const administrationNavBaseItems: INavData[] = [
  {
    name: 'Administration',
    url: '/administration',
    iconComponent: { name: 'cil-chart' },
    children: [
      {
        name: 'Users',
        url: '/backoffice/administration/admin-users',
        iconComponent: { name: 'cil-people' },
      },
    ]
  }
];
